import { useState, useEffect, useRef, useCallback } from "react";
import "./style.css";
import nextbtn from "../../Assets/images/arrow-right.png";
import defaultProfile from "../../Assets/images/placeholder.png";
import {
  editRelationship,
  deleteRelationship,
  fetchCategoriesAndTypes,
  uploadURL,
} from "../../Services/Realtionship";
import{
  parsePhoneNumberFromString,
} from "libphonenumber-js";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";
import { useHeader } from "../../Providers/HeaderContextProvider";

const NAME_REGEX = /^[A-Za-z0-9\s'-]+$/;

const EditRelationship = ({
  contact,
  onBack,
  onUpdateContact,
  onDeleteContact,
  navigateBack,
}) => {
  const { profileContent } = useHeader();

  const fileInputRef = useRef(null);
  const initialFormData = {
    first_name: contact.first_name || contact?.related_data?.first_name || "",
    last_name: contact.last_name || contact?.related_data?.last_name || "",
    relationship_type:
      contact?.related_data?.relationship_type ||
      contact?.relationship_type ||
      contact?.relationshipType ||
      "",
    relationship_length: (() => {
      const rawLen =
        contact?.related_data?.relationship_length ||
        contact?.relationship_length ||
        contact?.relationshipLength ||
        "";
      const birthYear = new Date(profileContent?.DOB || "").getFullYear();
      return rawLen == birthYear ? "Since Birth" : rawLen;
    })(),
    relationship_category:
      contact?.related_data?.relationship_category ||
      contact?.relationship_category ||
      contact?.relationshipCategory ||
      "",
    relationship_status:
      contact?.related_data?.relationship_status ||
      contact?.relationship_status ||
      contact?.relationshipStatus ||
      "",
    email: contact?.related_data?.email || contact?.email || "",
    country_code: contact?.mobile?.country_code || contact?.country_code || "",
    contact: contact?.mobile?.contact || contact?.contact || "",
    profile_pic_url: contact?.profile_pic_url || "",
  };

  useEffect(() => {
    const lenVal =
      contact?.related_data?.relationship_length ||
      contact?.relationship_length ||
      contact?.relationshipLength || "";
    const birthYear = new Date(profileContent?.DOB || "").getFullYear();
    if (lenVal && lenVal != birthYear) {
      setshowYearPicker(true);
    }
  }, [contact, profileContent?.DOB]);
  const [formData, setFormData] = useState(initialFormData);
  const [isEdited, setIsEdited] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(contact.profile_pic_url);
  const [selectedFile, setSelectedFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [relationTypes, setRelationTypes] = useState([]);
  const [relationLengths, setRelationLengths] = useState([]);
  const [relationStatuses, setRelationStatuses] = useState([]);
  const [isEditable, setIsEditable] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});
  const [issending, setIssending] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [showYearPicker, setshowYearPicker] = useState(false);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const categoriesData = await fetchCategoriesAndTypes();
        setCategories(Array.isArray(categoriesData) ? categoriesData : []);

        const lengthsData = await fetchCategoriesAndTypes("length");
        setRelationLengths(Array.isArray(lengthsData) ? lengthsData : []);

        const statusesData = await fetchCategoriesAndTypes("status");
        setRelationStatuses(Array.isArray(statusesData) ? statusesData : []);

        if (initialFormData.relationship_category) {
          const types = await fetchCategoriesAndTypes(
            initialFormData.relationship_category
          );
          setRelationTypes(Array.isArray(types) ? types : []);
        }

        if (contact.relation_status !== "nonExist") {
          setIsEditable(false);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    setIsEdited(
      JSON.stringify(formData) !== JSON.stringify(initialFormData) ||
        selectedFile !== null
    );
  }, [formData, selectedFile]);

 const handleInputChange = async (e) => {
  const { name, value } = e.target;
  const errors = {};
  
  if (name === "relationship_length" && value === "Select Year") {
    setFormData({ ...formData, relationship_length: "" });
    setshowYearPicker(true);
    return;
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // Get the current values to check combined length for names
  const currentFirstName = name === "first_name" ? value : formData.first_name;
  const currentLastName = name === "last_name" ? value : formData.last_name;
  const combinedLength = (currentFirstName || "").length + (currentLastName || "").length;

  if (name === "email") {
    if (value && !/\S+@\S+\.\S+/.test(value)) {
      errors.email = "Email is not valid";
    } else {
      errors.email = "";
    }
  }

  if (name === "first_name") {
    if (!value) {
      errors.first_name = "First name is required";
    } else if (combinedLength > 50) {
      errors.first_name = "First name and last name together cannot exceed 50 characters";
    } else if (value !== value?.trim()) {
      errors.first_name = "Name should not begin or end with spaces";
    } else if (!NAME_REGEX.test(value)) {
      errors.first_name = "Name should only contain letters, numbers, spaces, hyphens, and apostrophes";
    } else {
      errors.first_name = "";
    }
  }

  if (name === "last_name") {
    if (value) {
      if (combinedLength > 50) {
        errors.last_name = "First name and last name together cannot exceed 50 characters";
      } else if (value !== value?.trim()) {
        errors.last_name = "Name should not begin or end with spaces";
      } else if (!NAME_REGEX.test(value)) {
        errors.last_name = "Name should only contain letters, numbers, spaces, hyphens, and apostrophes";
      } else {
        errors.last_name = "";
      }
    }
  }

  // Last name validation (optional field)

  setValidationErrors({
    ...validationErrors,
    ...errors,
  });

  if (name === "relationship_category") {
    try {
      const response = await fetchCategoriesAndTypes(value);
      if (Array.isArray(response)) {
        setRelationTypes(response);
        setFormData((prev) => ({
          ...prev,
          relationship_type: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching relationship types:", error);
    }
  }
};

  const handlePhoneChange = (value) => {
    if (!value) {
      setFormData((prev) => ({
        ...prev,
        country_code: "",
        contact: "",
      }));
      return;
    }

    const phoneNumber = parsePhoneNumberFromString(value);
    if (phoneNumber) {
      setFormData((prev) => ({
        ...prev,
        country_code: "+" + phoneNumber.countryCallingCode,
        contact: phoneNumber.nationalNumber,
      }));
    }
  };

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      setError("Invalid file type. Accepted types: JPEG, PNG, JPG");
      return;
    }

    // Show local preview immediately (match AddRelationship behavior)
    try {
      const localUrl = URL.createObjectURL(file);
      setPreviewImage(localUrl);
    } catch (_) {}

    const data = {
      image: file.name,
      image_type: file.type.split("/")[1],
    };

    try {
      setError(null);
      setUploading(true);
      const UrlResponse = await uploadURL(contact._id, data);
      if (UrlResponse && UrlResponse.payload[0].upload_url) {
        try {
          const requestOptions = {
            method: "PUT",
            headers: {
              "Content-Type": file.type,
            },
            body: file,
          };
          const uploadResponse = await fetch(
            UrlResponse.payload[0].upload_url,
            requestOptions
          );
          if (uploadResponse.status === 200) {
            try {
              // Persist the uploaded image key to the relationship via editRelationship
              await editRelationship(contact._id, {
                profile_pic_url: UrlResponse.payload[0].s3_key,
              });
              setUploading(false);
              setSelectedFile(file);
              setIsEdited(true);
              return;
            } catch (error) {
              console.error("Error uploading photo:", error);
              setError(
                "Profile upload failed. You can upload it later in the profile section."
              );
              setUploading(false);
              return;
            }
          } else {
            console.error("Failed to upload photo:", uploadResponse.statusText);
            setError(
              "Profile upload failed. You can upload it later in the profile section."
            );
            setUploading(false);
            return;
          }
        } catch (error) {
          console.error("Error uploading image:", error);
          setError("Image upload failed. Please try again later");
          setUploading(false);
        }
        return;
      } else {
        setError("Image upload failed. Please try again later");
        setUploading(false);
        return;
      }
    } catch (error) {
      console.error("Error uploading URL:", error);
      setError("Image upload failed. Please try again later");
      setUploading(false);
    }

    setSelectedFile(file);
    setIsEdited(true);
  };

  const handleSubmit = async (e) => {
    if (issending) return;
    e.preventDefault();
    try {
      setIssending(true);
      const relationshipData = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        relationship_type: formData.relationship_type,
        relationship_length: formData.relationship_length,
        relationship_category: formData.relationship_category,
        relationship_status: formData.relationship_status,
        email: formData.email.toLowerCase() || null,
        country_code: formData.country_code || null,
        contact: formData.contact || null,
      };

      await editRelationship(contact._id, relationshipData);

      onUpdateContact?.({
        ...contact,
        ...relationshipData,
      });

      onBack();
    } catch (error) {
      console.error("Error updating relationship:", error.message);
    } finally {
      setIssending(false);
    }
  };

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteRelationship(contact._id);
      if (navigateBack) {
        navigate("/myprofile");
      }

      if (onDeleteContact) {
        onDeleteContact(contact.id);
      }

      setIsModalOpen(false);
      onBack();
    } catch (error) {
      console.error("Error deleting relationship:", error);
    }
  };

  const onResetDate = () => {
    setFormData({ ...formData, relationship_length: "" });
    setshowYearPicker(false);
  };

  const renderProfileContent = useCallback(() => {
    if (previewImage) {
      return (
        <div className="edit-profile-image">
          <img
            src={previewImage}
            alt={contact.first_name + contact.last_name}
            className="profile-picture"
            onError={(e) => {
              setPreviewImage(null);
              e.target.onerror = null;
            }}
          />
        </div>
      );
    } else if (contact.first_name || contact.last_name) {
      return (
        <div className="edit-profile-initials">
          {`${contact?.first_name?.[0]?.toUpperCase() || ""}${
            contact?.last_name?.[0]?.toUpperCase() || ""
          }` || ""}
        </div>
      );
    } else {
      return (
        <img
          src={defaultProfile}
          alt="default profile"
          className="default-profile"
        />
      );
    }
  }, [previewImage]);


  return (
    <div className="edit-container">
      <div className="edit-profile-section">
        <div className="edit-profile-image-container">
          <div>{renderProfileContent()}</div>
          <span
            className="edit-photo-text"
            onClick={handleImageClick}
            style={{ cursor: "pointer" }}
          >
            {uploading ? 'Uploading' : 'Edit photo'}
          </span>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            disabled={uploading}
            onChange={(e) => {
              if (!uploading) {
                handleImageChange(e);
              }
            }}
            style={{ display: "none" }}
          />
        </div>
      </div>

      <form onSubmit={handleSubmit} className="edit-form">
        <div className="edit-form-grid">
          <div className="edit-form-field">
            <label>First Name</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              required
              disabled={!isEditable} // Disable based on status
              style={{
                backgroundColor: !isEditable ? "#f0f0f0" : "",
                cursor: !isEditable ? "not-allowed" : "",
              }}
            />
            {validationErrors.first_name && (
              <p className="error-message name-align-left">
                {validationErrors.first_name}
              </p>
            )}
          </div>
          <div className="edit-form-field">
            <label>Last Name (optional)</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              disabled={!isEditable} // Disable based on status
              style={{
                backgroundColor: !isEditable ? "#f0f0f0" : "",
                cursor: !isEditable ? "not-allowed" : "",
              }}
            />
            {validationErrors.last_name && (
              <p className="error-message name-align-left">
                {validationErrors.last_name}
              </p>
            )}
          </div>

          <div className="form-group ">
            <label>Relationship Category</label>
            <select
              name="relationship_category"
              value={formData.relationship_category}
              onChange={handleInputChange}
            >
              {/* <option value="">{formData.relationship_category}</option> */}
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group ">
            <label>Relationship Type</label>
            <select
              name="relationship_type"
              value={formData.relationship_type}
              onChange={handleInputChange}
              disabled={!formData.relationship_category}
            >
              <option value="">Select Type</option>
              {relationTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Relationship Status</label>
            <select
              name="relationship_status"
              value={formData.relationship_status}
              onChange={handleInputChange}
            >
              {/* <option value="">{formData.relationship_status}</option> */}
              {relationStatuses.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>

          {/* <div className="edit-form-field">
            <label>Email (optional)</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              disabled={!isEditable} // Disable based on status
              style={{
                backgroundColor: !isEditable ? "#f0f0f0" : "",
                cursor: !isEditable ? "not-allowed" : "",
              }}
            />
          </div>
          <div className="form-group-mobile">
            <div style={{ marginBottom: "6px" }}>
              {" "}
              <label htmlFor="" className="mobile-label-addrelation">
                Mobile Number{" "}
              </label>
              <span className="mobile-label-addrelation">(optional)</span>
            </div>
            <PhoneInput
              id="phone-number"
              international
              defaultCountry="US"
              value={formData.country_code + formData.contact}
              onChange={handlePhoneChange}
              className="addrelationship-phoneinput"
              placeholder="Enter phone number"
              autoFocus={false}
              disabled={!isEditable} // Disable based on status
              style={{
                backgroundColor: !isEditable ? "#f0f0f0" : "",
                cursor: !isEditable ? "not-allowed" : "",
              }}
            />
          </div> */}
        </div>
        {error && <p className="error-message">{error}</p>}
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            type="submit"
            className={`edit-person-btn ${
              isEdited &&
              formData.relationship_type !== "" &&
              !validationErrors.first_name &&
              !validationErrors.last_name
                ? "filled"
                : ""
            }`}
            disabled={
              !isEdited ||
              formData.relationship_type === "" ||
              validationErrors.first_name ||
              validationErrors.last_name
            }
          >
            Update Relationship
            <img src={nextbtn} alt="next" className="nxtbtn" />
          </button>

          <button
            type="button"
            className="edit-delete-button"
            onClick={handleDeleteClick}
          >
            Delete Relationship
          </button>
        </div>
      </form>

      {isModalOpen && (
        <div className="dlt-modal-overlay">
          <div className="dlt-modal-content">
            <div className="dlt-modal-content-header">
              <h3>Are you sure you want to delete this relationship?</h3>
              <button
                className="dlt-modal-close-btn"
                onClick={handleCloseModal}
              >
                <CloseIcon />
              </button>
            </div>
            <p className="dlt-modal-content-para">
              You won't be able to get advice on this person anymore.
            </p>
            <div className="dlt-modal-actions">
              <button
                className="dlt-modal-cancel-btn"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button
                className="dlt-modal-confirm-btn"
                onClick={handleConfirmDelete}
              >
                Yes, Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditRelationship;
